export default function PageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-8 h-8 border-2 border-neutral-200 border-t-amber-600 rounded-full animate-spin" />
    </div>
  );
}
